export default "__VITE_ASSET__ByLgX3KD__"